import { render, staticRenderFns } from "./SentenceCard.vue?vue&type=template&id=a66e1ad6&"
import script from "./SentenceCard.vue?vue&type=script&lang=js&"
export * from "./SentenceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports